






import { Component, Vue, Prop } from "vue-property-decorator";
import ProductListContainer from '@/components/ProductListContainer/ProductListContainer';

@Component({
    components: {
        ProductListContainer
    }
})
export default class CatalogSpec extends Vue {
    @Prop() spec!: string
}
